module.exports = __webpack_public_path__ + "static/media/gryphon_musee_everyartoriginal_2.97ed96d7.jpg";